import { config } from "config";
import { IGetPinEncryptionDetailsResponse } from "types/login";
import { ITypedAPITarget } from "./NetworkStapler";

export function getLoginUrl(clientId: string, redirectUri?: string) {
    return `${config.network.loginBaseUrlHttps}/sts/oauth/authorize?response_type=token&client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri ?? "")}`;
}

export function getPinEncryptionDetails(): ITypedAPITarget<IGetPinEncryptionDetailsResponse> {
    return {
        url: "/sts/encryption/public/credentials",
        headers: {
            "Accept": "application/json"
        },
        method: "GET",
        parse: (json: any) => json as IGetPinEncryptionDetailsResponse
    };
}


// WEBPACK FOOTER //
// ./src/network/LoginAPI.ts